import axios from "axios";
var pointGroups = [];
var pointMarkers = [];
var lineGroups = [];
var workLineGroups = [];
var overlayGroups = [];
var websock;
export default {
  //新的封装
  //时间戳转变为各种格式
  time(t, j) {
    if (this.isEmpty(t)) {
      return "";
    }
    var d = new Date(t);
    var result;
    var yy = d.getFullYear();
    var mm = d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
    var dd = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    var h = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
    var m = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
    var s = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
    if (j == "yymmdd") {
      result = yy + "-" + mm + "-" + dd;
    } else if (j == "yymm") {
      result = yy + "-" + mm;
    } else if (j == "mmdd") {
      result = mm + "-" + dd;
    } else if (j == "hhmm") {
      result = h + ":" + m;
    } else if (j == "yymmddhhmm") {
      result = yy + "-" + mm + "-" + dd + " " + h + ":" + m;
    } else {
      result = yy + "-" + mm + "-" + dd + " " + h + ":" + m + ":" + s;
    }
    return result;
  },
  sjcTo(t) {
    if (this.isEmpty(t)) {
      return "";
    } else {
      return new Date(t);
    }
  },
  //对象格式改为时间戳
  toSjc(t) {
    if (this.isEmpty(t)) {
      return "";
    } else {
      return t.getTime();
    }
  },
  //文本处理
  text(t, k) {
    if (this.isEmpty(t)) {
      return k || "";
    } else {
      return t;
    }
  },
  //近几天快速选择
  days(t1, t2, k) {
    //k,表示结束时间是否都是23：59：59
    //获取今天0点时间戳
    //var t = new Date(new Date().toLocaleDateString());
    var tt = this.time(Date.now(), "yymmdd").replace(/-/g, "/");
    const timestamp = new Date(tt).getTime();
    var start = timestamp + 86400000 * t1;
    var end = "";
    t2 == 0 && k
      ? (end = Date.now())
      : (end = timestamp + 86400000 * t2 + 86399000);
    return { start: start, end: end };
  },
  //数组去重
  qcArr(arr) {
    let newArr = [];
    let obj = {};
    for (var i = 0; i < arr.length; i++) {
      if (!obj[arr[i].key]) {
        newArr.push(arr[i]);
        obj[arr[i].key] = true;
      }
    }
    return newArr;
  },
  //地址解析
  jiexi(pointList, pointType) {
    var params = {
      orgCoord: 1,
      pointList: pointList,
      returnCoord: (pointType = pointType || 2),
    };
    var promise = new Promise((resolve) => {
      axios({
        method: "post",
        url: axios.lbs + "/lbs/geocoding",
        data: params,
      }).then((res) => {
        if (res.data.code == 200) {
          resolve(res.data.data);
        }
      });
    });
    return promise;
  },
  getGroupTree() {
    var promise = new Promise((resolve) => {
      axios({
        method: "post",
        url: axios.bm + "/group/tree",
        data: {},
      }).then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          function daes(data) {
            for (let i = 0; i < data.length; i++) {
              data[i].children = data[i].childList;
              data[i].title = data[i].name;
              data[i].expand = false;
              data[i].checked = false;
              data[i].selected = false;
              if (data[i].childList.length > 0) {
                daes(data[i].childList);
              }
            }
            return data;
          }

          resolve(daes(res.data.data));
        }
      });
    });
    return promise;
  },
  //渲染标注点
  showPoints(map, v) {
    console.log(v);
    map.remove(pointGroups);
    var polyArrs = [];
    map.remove(pointMarkers);
    for (var i = 0, marker; i < v.length; i++) {
      marker = new AMap.Marker({
        map: map,
        position: [v[i].x, v[i].y],
        /* icon:
            "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png", */
        offset: new AMap.Pixel(-10, -30),
      });
      marker.setLabel({
        offset: new AMap.Pixel(0, 0), //设置文本标注偏移量
        content:
          "<div class='myInfo' style='font-size:12px'>" + v[i].name + "</div>", //设置文本标注内容
        direction: "top", //设置文本标注方位
      });
      pointMarkers.push(marker);
      var circle = new AMap.Circle({
        center: [v[i].x, v[i].y],
        radius: v[i].radius, //半径
        borderWeight: 3,
        strokeColor: "#FF33FF",
        strokeOpacity: 0.2,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.2,
        strokeStyle: "dashed",
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: "#1791fc",
      });
      polyArrs.push(circle);
    }
    pointGroups = new AMap.OverlayGroup(polyArrs);
    map.add(pointGroups);
    map.setFitView();
  },
  //渲染路线
  showLines(map, v) {
    map.remove(lineGroups);
    // lineGroups
    var polyArrs = [];
    var paths = [];
    for (var i = 0; i < v.length; i++) {
      var add = [];
      for (const j in v[i].coordList) {
        var dd = v[i].coordList[j];
        var small = new AMap.LngLat(dd.x, dd.y);
        add.push(small);
      }
      paths.push(add);

      // 创建线实例
      var polyline = new AMap.Polyline({
        path: paths[i],
        borderWeight: 4,
        strokeColor: "red",
      });
      polyArrs.push(polyline);
    }
    lineGroups = new AMap.OverlayGroup(polyArrs);
    map.add(lineGroups);
    map.setFitView();
    //原有的图形
  },
  showWorksLines(map, v) {
    map.remove(workLineGroups);
    // lineGroups
    var polyArrs = [];
    var paths = [];
    for (var i = 0; i < v.length; i++) {
      var add = [];
      for (const j in v[i].pointList[0]) {
        var dd = v[i].pointList[0][j];
        var small = new AMap.LngLat(dd.x, dd.y);
        add.push(small);
      }
      paths.push(add);

      // 创建线实例
      var polyline = new AMap.Polyline({
        path: paths[i],
        borderWeight: 8,
        strokeColor: "blue",
      });
      polyArrs.push(polyline);
    }
    workLineGroups = new AMap.OverlayGroup(polyArrs);
    map.add(workLineGroups);
    //map.setFitView();
    //原有的图形
  },
  //渲染围栏
  showFences(map, v) {
    console.log(v);
    map.remove(overlayGroups);
    if (v.length == 0) {
      return;
    }
    var polyArrs = [];

    var paths = [];
    for (var i = 0; i < v.length; i++) {
      var add = [];
      for (const j in v[i].coordList) {
        var dad = [];
        for (const k in v[i].coordList[j]) {
          var dd = v[i].coordList[j][k];
          var small = new AMap.LngLat(dd.x, dd.y);
          dad.push(small);
        }
        add.push(dad);
      }
      paths.push(add);
      // 创建线实例
      var polygon = new AMap.Polygon({
        path: paths[i],
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        //fillColor: "#309ef8",
        fillColor: "green",
        zIndex: 50,
      });
      polyArrs.push(polygon);
    }
    console.log(paths);
    overlayGroups = new AMap.OverlayGroup(polyArrs);
    map.add(overlayGroups);
    map.setFitView();
  },
  //方向
  direction(t) {
    var d = {
      1: "北",
      2: "东北",
      3: "东",
      4: "东南",
      5: "南",
      6: "西南",
      7: "西",
      8: "西北",
    };
    return this.isEmpty(t) ? "无" : d[t];
  },
  //毫秒化为时长
  duration(t) {
    if (t == null) {
      return 0;
    }
    var m = 0;
    var h = Math.floor(t / (60 * 60));
    var min = Math.floor((t - h * 60 * 60) / 60);
    m = (h == 0 ? "" : h + "小时") + (min == 0 ? "<1分" : min + "分");
    return m;
  },
  //相对时间计算
  xdsj(start) {
    var dd = (Date.now() - start) / 1000;
    var time = "";
    if (start == null) {
      time = "";
    } else {
      if (dd < 0) {
        time = 0;
      } else if (0 <= dd && dd < 60) {
        //1分钟内
        time = "刚刚";
      } else if ((60 <= dd) & (dd < 3600)) {
        //1小时内
        time = parseInt(dd / 60) + "分钟";
      } else if (3600 <= dd && dd < 24 * 3600) {
        //大于1小时小于24小时
        time = parseInt(dd / 3600) + "小时";
      } else if (24 * 3600 <= dd) {
        //超过24小时
        time = parseInt(dd / (3600 * 24)) + "天";
      }
    }
    return time;
  },
  //分钟转换小时
  minTime(t) {
    if (t <= 60) {
      return t + "分钟";
    } else if (t > 60) {
      return parseInt(t / 60) + "小时" + (t % 60) + "分";
    }
  },
  //取到的值为空的处理
  isEmpty(param) {
    if (param == null || param.length == 0 || param == "null") {
      return true;
    } else {
      return false;
    }
  },
  //开始时间判断
  jcTime(_this, t) {
    var limit = t.limit || 365;
    var text1 = t.text1 || "开始时间";
    var text2 = t.text2 || "结束时间";
    if (this.isEmpty(t.startTime)) {
      _this.$Message.error(text1 + "不能为空");
      return false;
    } else if (this.isEmpty(t.endTime)) {
      _this.$Message.error(text2 + "不能为空");
      return false;
    } else if (t.startTime.getTime() >= t.endTime.getTime()) {
      _this.$Message.error(text1 + "不能大于" + text2);
      return false;
    } else if (t.endTime.getTime() - t.startTime.getTime() > 86400000 * limit) {
      _this.$Message.error({
        content: "暂时只支持查询（或导出）" + limit + "天以内的数据",
        duration: 3,
      });
      return false;
    } else {
      return true;
    }
  },
  exportData(url, params) {
    var href =
      url +
      "?accessToken=" +
      encodeURIComponent(encodeURIComponent(axios.keyObj.accessToken));
    for (const i in params) {
      href += "&" + params[i].name + "=" + params[i].value;
    }
    window.open(href);
  },
  //导出报表
  downLoad(url) {
    var href =
      url +
      "?accessToken=" +
      encodeURIComponent(encodeURIComponent(axios.keyObj.accessToken));

    window.open(href);
  },
  //加载动画
  loading(that, text) {
    that.$Spin.show({
      render: (h) => {
        return h("div", [
          h("Icon", {
            class: "demo-spin-icon-load",
            props: {
              type: "ios-loading",
              size: 40,
            },
          }),
          h("div", text),
        ]);
      },
    });
  },
  //毫秒化为时长
  duration6(t) {
    if (t == null) {
      return 0;
    }
    var m = 0;
    var h = Math.floor(t / (60 * 60));
    var min = Math.floor((t - h * 60 * 60) / 60);
    m = (h == 0 ? "" : h + "小时") + (min == 0 ? "" : min + "分");
    return m;
  },
  //货币格式转换
  formatMoney(number, places, symbol, thousand, decimal) {
    number = number || 0;
    places = !isNaN((places = Math.abs(places))) ? places : 2;
    //symbol = symbol !== undefined ? symbol : "￥";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var negative = number < 0 ? "-" : "",
      i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      //symbol +
      negative +
      (j ? i.substr(0, j) + thousand : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
      (places
        ? decimal +
          Math.abs(number - i)
            .toFixed(places)
            .slice(2)
        : "")
    );
  },
  //前端分页
  page(number, pageSize, data) {
    var pagedata = [];
    let start = pageSize * number - pageSize;
    let end = pageSize * number;
    end = end > data.length ? data.length : end;
    for (let i = start; i < end; i++) {
      pagedata.push(data[i]);
    }
    return pagedata;
  },
  //设置地图中心点
  setMap(map) {
    //var m = JSON.parse(axios.mapConfig);
    //var zoom = m == null ? 5 : m.zoom;
    //var point = m == null ? [107.558051001, 23.32482143] : m.mapCenter;
    //map.setZoom(zoom);
    //map.setCenter(point);
  },
  //websock
  ws: {},
  setWs(newWs) {
    this.ws = newWs;
  },
  //选择文本
  selectText(element) {
    var text = document.getElementById(element);
    if (document.body.createTextRange) {
      var range = document.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
      /*if(selection.setBaseAndExtent){
          selection.setBaseAndExtent(text, 0, text, 1);
      }*/
    } else {
      alert("none");
    }
  },
  replace(url) {
    url = url.replace(axios.platConfig.fileUri, "");
    return url;
  },
  cols(forms, n, config) {
    var b = JSON.parse(JSON.stringify(forms));
    b = b.filter(function (item) {
      return !item.noTable;
    });
    //b.splice(2, 4);
    for (let i = 0; i < n.length; i++) {
      if (config) {
        if (!n[i].minWidth) {
          n[i].minWidth = config.min;
        }
        if (!n[i].maxWidth) {
          n[i].maxWidth = config.max;
        }
      }
    }
    for (let i = 0; i < b.length; i++) {
      b[i].sort = i + 1;
      if (config) {
        if (!b[i].minWidth) {
          b[i].minWidth = config.min;
        }
        if (!b[i].maxWidth) {
          b[i].maxWidth = config.max;
        }
      }

      if (b[i].key1) {
        b[i].key = b[i].key1;
      }
      if (b[i].key2) {
        b[i].key = b[i].key2;
      }
    }

    //this.columns.splice(3, 0, ...b);

    n = n.concat(b).sort(function up(x, y) {
      return x.sort - y.sort;
    });
    return n;
    //a.splice.apply(a,[i,0].concat(b));//es5写法
  },
  //旧的
  ale123(_this, m) {
    //alert(m);
    _this.$Message.error(m);
  },
  ac(vueObject) {
    console.log(vueObject); //如何让这里的this这项vue实例的this，就是借用了参数，在实例中把改参数换成this接口
  },
  //设置表格高度
  setTableHeight(j) {
    //j为调整值得
    var h = document.body.clientHeight;
    h = h - j;
    return h;
  },
  toSearchData(vueObject, search) {
    //表格内容搜索
    if (search) {
      vueObject.searchData = vueObject.products.filter(function (product) {
        //console.log(product)
        return Object.keys(product).some(function (key) {
          //console.log(key)
          return String(product[key]).toLowerCase().indexOf(search) > -1;
        });
      });
    } else {
      vueObject.searchData = vueObject.products;
    }
  },
  //时间转换 年月日时分秒
  day(t) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return (
        d.getFullYear() +
        "-" +
        m +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds()
      );
    } else {
      return t;
    }
  },
  //时间转换 年月日
  yyMmDd(t, val) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m + "-" + d.getDate() + " " + val;
    } else {
      if (val == undefined) {
        return t;
      } else {
        return t + " " + val;
      }
    }
  },
  //顶部菜单
  changeTopMenu(_this, row) {
    setTimeout(() => {
      var result = _this.$store.state.topMenuList.some((item) => {
        if (item.link == row.link) {
          return true;
        }
      });
      if (!result) {
        row.now = _this.$route.query.now;
        _this.$store.state.topMenuList.push(row);
      }
    }, 100);
  },
  //报表导出需要
  changeToYyMmDd(t) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m + "-" + d.getDate();
    } else {
      return t;
    }
  },
  //报表导出需要
  changeToYyMm(t) {
    var aaa = typeof t;
    if (aaa == "object") {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return d.getFullYear() + "-" + m;
    } else {
      return t;
    }
  },
  //查找用户组树结构路径
  findPath(node, userGroupId, path) {
    if (!path) {
      path = [];
    }
    if (node.userGroupId === userGroupId) {
      return path;
    }
    path.push(node);
    if (node.children) {
      if (
        node.children.some((child) => this.findPath(child, userGroupId, path))
      ) {
        return path;
      }
    }

    path.pop();
    return false;
  },
  //获取系统时间 年月日
  getDay(day) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  },
  //配合上GetDay函数使用的
  doHandleMonth(month) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  },
  //秒钟转化为小时，天,用在定位里边的车辆
  changeTime(t) {
    var m;
    if (t == null) {
      m = "";
    } else {
      if (t / 60 < 1) {
        m = t + "秒";
      } else if (t / 60 >= 1 && t / 60 / 60 < 1) {
        m = parseInt(t / 60) + "分钟";
      } else if (t / 60 / 60 >= 1 && t / 60 / 60 / 24 < 1) {
        m = parseInt(t / 60 / 60) + "小时";
      } else if (t / 60 / 60 / 24 >= 1) {
        m = parseInt(t / 60 / 60 / 24) + "天";
      }
    }

    return m;
  },
  //精确计算时间
  changeTimeDetail(t) {
    var m;
    let min = t % 24;
    if (t / 60 < 1) {
      m = "";
    } else if (t / 60 >= 1 && t / 60 < 24) {
      m = parseInt(t / 60) + "小时" + (min < 10 ? "0" + min : min) + "分";
    } else if (t / 60 >= 24) {
      let h = parseInt((t % 1440) / 60); //一天1440分钟
      m =
        parseInt(t / 60 / 24) +
        "天" +
        (h < 10 ? "0" + h : h) +
        "小时" +
        (min < 10 ? "0" + min : min) +
        "分";
    }
    return m;
  },
  //重置表单
  resetForm(_this, name) {
    _this.$refs[name].resetFields();
  },
};
//在main中引用，在实际的组件中就可以调用各种方法了
//组件中调用方法：this.utils.exportData(this, m, "车辆日常报表");



// WEBPACK FOOTER //
// ./src/util/util.js